const packageDetails = [
    {
    id: "1",
    packageName: "Exercise Plan",
    description: "An exercise plan is essentially a 'roadmap' that clearly identifies for the client the steps they'll need to take to reach their desired destination. Research has shown that goal setting greatly increases the chances of adherence and the achievement of outcomes.",
    packageDuration: "3 Months",
    packageFee: 7000,
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS8Rd-ekOqQ2feh2V9GXRWiOqPV3tvsASc38Q&usqp=CAU"
  },
  {
    id: "2",
    packageName: "Food Plan",
    description: "Meal planning is the simple act of planning and writing down any of your meals for the week (or month!) ahead of time. ... Plan to eat wholesome meals, and plan a night out or two. Plan every snack and meal, or simply plan your lunches.",
    packageDuration: "1 Year",
    packageFee: 3000,
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT4rQnRZ_WFvhdznmQXn7UOWiAHjRcNZP7g1g&usqp=CAU"
  },
  {
    id: "3",
    packageName: "Yoga Session",
    description: "Yoga is a group of physical, mental, and spiritual practices,disciplines that originated in ancient India, aimed at controlling and stilling the mind, and recognizing the detached as untouched by the activities of the mind and suffering. ",
    packageDuration: "6 Months",
    packageFee: 9000,
    image: "https://www.holisticwellnesspractice.com/wp-content/uploads/2020/10/Why-You-Need-Private-Yoga-scaled.jpg"
  },
  {
    id: "4",
    packageName: "Meditation Session",
    description: "Meditation is considered a type of mind-body medicine. Meditation can produce a deep state of relaxation and a tranquil mind. During meditation, you focus your attention and eliminate the stream of jumbled thoughts that may be crowding your mind.",
    packageDuration: "1 Month",
    packageFee: 5200,
    image: "https://media.npr.org/assets/img/2014/01/07/mindfulness_wide-b20c3525971d5796eba9ad993463fffe8faf2bcb-s1100-c50.jpg"
  },
  {
    id: "5",
    packageName: "Personal Training",
    description: "A personal trainer is an individual who has earned a certification that demonstrates they have achieved a level of competency for creating safe and effective exercise programs for healthy individuals and groups with medical clearance to exercise.",
    packageDuration: "6 Months",
    packageFee: 9000,
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQombNKAz9DztDx3_tcvzEd6Ei5NIuJoOvVXg&usqp=CAU"
  },
  {
    id: "6",
    packageName: "Mental Health Support",
    description: "Mental health includes our emotional, psychological, and social well-being. It affects how we think, feel, and act. It also helps determine how we handle stress, relate to others, and make choices. Mental health is important at every stage of life.",
    packageDuration: "3 Months",
    packageFee: 3000,
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRb9voOvdXa-rqBBzFl0B3XOfnBUup4N6hD9g&usqp=CAU"
  }
]

export default packageDetails;